// Notifications helper — fires a system notification when a flash
// triggers while the TimeFlash tab is backgrounded.

export const supportsNotifications = () =>
  typeof window !== "undefined" && "Notification" in window;

export const notificationPermission = () =>
  supportsNotifications() ? Notification.permission : "unsupported";

export const requestNotificationPermission = async () => {
  if (!supportsNotifications()) return "unsupported";
  if (Notification.permission === "granted") return "granted";
  if (Notification.permission === "denied") return "denied";
  try {
    const res = await Notification.requestPermission();
    return res;
  } catch {
    return "denied";
  }
};

/**
 * Fire a notification if the user granted permission and the tab is hidden.
 * Prefers Service Worker notifications (which can be sticky + show on lock screen on Android).
 * Falls back to the plain Notification constructor.
 */
export const notifyFlash = async ({ title, body }) => {
  if (!supportsNotifications()) return false;
  if (Notification.permission !== "granted") return false;

  const options = {
    body,
    icon: "/icons/icon-192.png",
    badge: "/icons/icon-192.png",
    tag: "timeflash-flash",
    renotify: true,
    requireInteraction: true,
    vibrate: [400, 200, 400, 200, 400],
    silent: false,
  };

  // Prefer service-worker notification if available (Android lock screen, sticky)
  if ("serviceWorker" in navigator) {
    try {
      const reg = await navigator.serviceWorker.getRegistration();
      if (reg && reg.showNotification) {
        await reg.showNotification(title, options);
        return true;
      }
    } catch {}
  }

  try {
    const n = new Notification(title, options);
    n.onclick = () => {
      window.focus();
      n.close();
    };
    return true;
  } catch {
    return false;
  }
};

export const closeFlashNotifications = async () => {
  if (!("serviceWorker" in navigator)) return;
  try {
    const reg = await navigator.serviceWorker.getRegistration();
    if (!reg) return;
    const nots = await reg.getNotifications({ tag: "timeflash-flash" });
    nots.forEach((n) => n.close());
  } catch {}
};
